import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../store/useAuthStore";
import axios from "../api/axiosInstance";
import Cookies from "js-cookie";
import SERVER_URL from "../config/server";
import toast from "react-hot-toast";

const UserAvatarUpload = () => {
  const { isLoggedIn, checkAuth, ProfilePicture, setProfilePicture } =
    useAuthStore();
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [uploading, setUploading] = useState(false);
  const navigate = useNavigate();
  const ProfileImage = SERVER_URL + ProfilePicture;

  useEffect(() => {
    checkAuth(); // Ensure user data is fresh
  }, [checkAuth]);

  if (!isLoggedIn) {
    return (
      <div className="min-h-screen flex items-center justify-center text-white">
        Loading...
      </div>
    );
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) return;
    setUploading(true);

    try {
      const formData = new FormData();
      formData.append("avatar", selectedFile);
      const token = Cookies.get("token"); // Get token from cookies or Zustand

      const response = await axios.post("/user/upload-avatar", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`, // ✅ Send token
        },
        withCredentials: true, // ✅ If you are using cookies for other things
      });

      if (response.status === 200) {
        setProfilePicture(response.data.ProfileImage);
        await checkAuth();

        toast.success("Profile Picture Updated Successfully!", {
          duration: 2000,
        });

        setSelectedFile(null);
        setPreviewUrl("");

        setTimeout(() => {
          navigate("/profile"); // Redirect after success
        }, 2000);
      } else {
        toast.error("Upload failed. Try again.");
      }
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Something went wrong!");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="min-h-screen text-white flex flex-col items-center justify-center p-4">
      <div className="bg-gray-800/80 backdrop-blur-lg p-6 rounded-2xl shadow-lg w-full max-w-md space-y-6 text-center">
        <h2 className="text-3xl font-bold text-indigo-400 mb-4">
          Update Avatar
        </h2>

        {/* Current Avatar */}
        <div className="flex justify-center">
          <img
            src={ProfileImage}
            alt="Current Avatar"
            className="w-32 h-32 rounded-full object-cover border-4 border-indigo-500 shadow-md"
          />
        </div>

        {/* File Input */}
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="text-white mt-3"
        />

        {/* Preview New Image */}
        {previewUrl && (
          <div className="flex justify-center mt-4">
            <img
              src={previewUrl}
              alt="Preview"
              className="w-32 h-32 rounded-full object-cover border-2 border-indigo-300"
            />
          </div>
        )}

        {/* Upload Button */}
        <button
          onClick={handleUpload}
          disabled={uploading || !selectedFile}
          className="mt-4 w-full bg-indigo-500 hover:bg-indigo-600 py-2 px-4 rounded-lg transition disabled:opacity-50"
        >
          {uploading ? "Uploading..." : "Upload Avatar"}
        </button>
      </div>
    </div>
  );
};

export default UserAvatarUpload;
